import { Copy, MapPin } from "lucide-react";
import { toast } from "sonner";
import { formatCep } from "@/lib/viacep";
import {
  entregaDoPedido,
  enderecoParaEtiqueta,
  type ColunasDeEntrega,
} from "@/components/prosthesis/endereco-de-entrega";

/** Para onde o trabalho volta, com "Copiar endereço". Etiquetas e recibo ficam no "Imprimir" do
 *  cabeçalho do dialog (`MenuDeImpressao`). */
export function EntregaDoPedidoBloco({ order }: { order: ColunasDeEntrega }) {
  const entrega = entregaDoPedido(order);

  if (!entrega) {
    return (
      <p className="flex items-center gap-2 rounded-lg bg-zinc-50 px-3 py-2 text-[12.5px] text-zinc-500 dark:bg-background/50 dark:text-muted-foreground">
        <MapPin className="h-3.5 w-3.5 shrink-0" />
        Pedido sem endereço de envio — a clínica não tinha endereço cadastrado quando enviou.
      </p>
    );
  }

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(enderecoParaEtiqueta(entrega));
      toast.success("Endereço copiado.");
    } catch {
      toast.error("Não foi possível copiar.");
    }
  };

  return (
    <div className="flex items-start gap-2 rounded-lg border border-zinc-200 p-3 dark:border-border">
      <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-600 dark:text-primary" />
      <div className="min-w-0 flex-1 text-sm">
        <p className="text-[11px] uppercase tracking-wide text-zinc-500 dark:text-muted-foreground">Entrega</p>
        <p className="font-semibold text-zinc-900 dark:text-foreground">{entrega.destinatario}</p>
        <p className="text-zinc-700 dark:text-foreground/80">
          {entrega.endereco}, {entrega.numero}
          {entrega.complemento ? ` — ${entrega.complemento}` : ""}
        </p>
        <p className="text-zinc-700 dark:text-foreground/80">
          {entrega.bairro} · {entrega.cidade}/{entrega.uf} · CEP {formatCep(entrega.cep)}
        </p>
        {entrega.telefone && <p className="text-zinc-500 dark:text-muted-foreground">Tel. {entrega.telefone}</p>}
      </div>
      <button
        type="button"
        onClick={copiar}
        title="Copiar endereço"
        aria-label="Copiar endereço"
        className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-zinc-500 transition-colors hover:bg-zinc-100 hover:text-zinc-800 dark:text-muted-foreground dark:hover:bg-muted dark:hover:text-foreground"
      >
        <Copy className="h-4 w-4" />
      </button>
    </div>
  );
}
